import React from 'react'
import { BlockMain } from '@blocks/BlockMain'
import { ApplicationForms } from '@shared/components/forms/application'
import { scrollToApplicationForm } from '@shared/components/forms/application/cross'
import PageAnimation from '@shared/components/page-animation'
import { mainBlock } from 'data/vse-budet-horosho'

import { Steps } from './sections/steps'

import styles from './style.module.scss'

export const View = () => (
	<PageAnimation>
		<BlockMain
			adornmentClassname={styles.mainAdornment}
			imageAdornmentWrapClassName={styles.imageAdornment}
			data={mainBlock}
			buttonProps={{
				onClick: scrollToApplicationForm,
			}}
		/>
		<Steps />
		<ApplicationForms.Cross
			processBarText='Вероятность одобрения рефинансирования'
			formTitle='Заявка на рефинансирование'
			// isRefinance
		/>
	</PageAnimation>
)
